pageId = 'page-members'
page = '#' + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('#nav-members').addClass('active')
  bind()
  checkStore()
  tower.showBubbleGuide steps: [10]
  autoLoad()

  if location.hash
    group = location.hash.slice(1)
    $(".member-group[data-group-id=#{group}]").click()

bind = ->
  $(document).on 'click', '.visitor-group-link', (e) ->
    e.preventDefault()
    $(".member-group[data-group-id='visitor']").trigger('click')

  key = "#{ simple.url().toString('relative') }member-group"
  $groups = $('.member-groups')
  $groups.on 'click', '.member-group', ->
    $link = $(@)
    group = $link.data('group-id')
    $link.addClass('active').siblings('.active').removeClass 'active'

    $('.group-title').attr('data-group-id', group)
    $('#group-title-content').text $link.attr('title')
      .next().html $link.data('group-count')
    filterMembers group
    toggleInit group unless isAutoLoadCompleted()

    simple.util.storage.set key, group

filterMembers = (group) ->
  filterMembersHelper $('.table-members'), group

filterMembersHelper = ($el, group) ->
  $el.find('.member').hide()
  if group == 'all'
    $el.find('.member').show()
  else if group == 'visitor'
    $el.find('.member[data-visitor="true"]').show()
  else
    $el.find(".member[data-group-ids*='#{ group }']").show()

toggleInit = (group) ->
  $('.init-members').hide()
  if group == 'visitor'
    $('.init-visitor').toggle $('.member:visible').length == 0
  else if group != 'all'
    $('.init-group').toggle $('.member:visible').length == 0

checkStore = (key) ->
  key = "#{ simple.url().toString('relative') }member-group"
  group = simple.util.storage.get(key) || 'all'
  $(".member-group[data-group-id='#{group}']").trigger('click')

autoLoad = ->
  return unless getAutoLoad().length > 0
  showSpinner()
  $.ajax
    url: location.href
    data: { page: nextPageNumber() },
    method: 'get'
    dataType: 'json'
  .done (data, status, xhr) ->
    hideSpinner()
    removeSpinner() if data.is_last_page
    if xhr.status != HTTP_STATUS_NO_CONTENT && data.html.trim().length > 0
      $members = $(data.html)
      $members.hide().appendTo $('.table-members tbody')
      filterMembersHelper $('.table-members'), getCurrentGroup()
      setCurrentPageNumber(data.page)
      if data.is_last_page
        getAutoLoad().remove()
        toggleInit()
      else
        autoLoad()

isAutoLoadCompleted = ->
  $('#page-members #auto-load-more').length > 0

getAutoLoad = ->
  $('#page-members #auto-load-more')

showSpinner = ->
  $spinner =
    if $('.table-members').siblings('.spinner')[0]
      $('.table-members').siblings('.spinner').first()
    else
      $('<div class="spinner"><i class="twr twr-refresh twr-spin"></i></div>')
        .insertAfter($('.table-members'))
  $spinner.fadeIn(250)

hideSpinner = ->
  $('.table-members').siblings('.spinner').fadeOut(250)

removeSpinner = ->
  $('.table-members').siblings('.spinner').remove()

getCurrentGroup = ->
  group = $('.member-group.active')
  if group
    group.data('group-id')
  else
    'all'

setCurrentPageNumber = (pageNumber) ->
  getAutoLoad().data('page-number', pageNumber)

nextPageNumber = ->
  Number(getAutoLoad().data('page-number') || 1) + 1

